import { ElementRef, EventEmitter } from '@angular/core';
import { INode, NodeTypeEnum } from '../../../services/eleview/types/model';
import { Node } from '../../../services/eleview/types/node';

export interface DragData {
	Type: 'column' | 'node';
	Data: string | Node;
}
export class EditLabelService {
	dragData: DragData;
	prevNodeEle: ElementRef;
	dragOverNode: Node;
	dragOverArea: string;
	onNodeChange = new EventEmitter();

	buildDragedNode(): INode {
		let node: INode;
		switch (this.dragData.Type) {
			case 'column':
				node = {
					NodeType: NodeTypeEnum.NodeCondition,
					Field: this.dragData.Data as string,
					Operate: '='
				};
				break;
			case 'node':
				node = (this.dragData.Data as Node).toInterface();
				break;
		}
		return node;
	}
}
